import { render } from "./EditTickets.vue?vue&type=template&id=ffe413c2&scoped=true"
import script from "./EditTickets.vue?vue&type=script&lang=js"
export * from "./EditTickets.vue?vue&type=script&lang=js"

import "./EditTickets.vue?vue&type=style&index=0&id=ffe413c2&scoped=true&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe413c2"]])

export default __exports__